import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from '@/i18n/index'
import router from '@/router/index'
import "@/assets/font/font.scss";
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: "en",
  messages,
})
//portrait landscape
let direction = ''

landOrpro()

Vue.prototype.$mlog = new Mlog({
  activity: 'creatorcamp',
});

Vue.prototype.$mlog.visitLog({
  behavior: "visit",
  type: direction
})

window.addEventListener('orientationchange', () => {
  setTimeout(() => {
    landOrpro()
    Vue.prototype.$mlog.visitLog({
      behavior: "switch",
      type: direction
    })
  }, 300)
}, false)

function landOrpro () {
  if (window.orientation === 180 || window.orientation === 0) {
    direction = 'portrait'
  }
  if (window.orientation === 90 || window.orientation === -90) {
    direction = 'landscape'
  }
}

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
